import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { IdentityProvidersReferenceData } from "@idw-types/state/identity-providers-state";

export const getIdentityProvidersReferenceDataRequest = async (): Promise<{ data: IdentityProvidersReferenceData, error: any }> => {
    const route = apiRoutes.idpConfiguration.identityProviderConfig.list.referenceData;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};